/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useContext, useState} from 'react';
import dayjs from '../../../utils/config/dayjs';
import Plotly from 'plotly.js-dist-min';
import 'react-datepicker/dist/react-datepicker.css';
import {Radio, Modal, Loader, InputDate, PowerDropdown, FluidContainer} from '../../../components';
import {
  RadiosContainer,
  TableWrapper,
  RadiosWrapper,
  ArmRecoveryContainer,
  TextContainer,
  AlertContainer,
  AlertWrapper,
  Oval,
  ExamInfoContainer,
  ExamRadios,
  ArmRecoveryInfoButton,
  ArmRecoveryTop,
  RadiosWrap,
  KeyMetricsGraphic,
  ContainerDropdown,
  WrapperFilter,
  MiddleText,
  MiddleTextStrong,
  FilterContainer,
} from '../styles';
import {
  ModalTop,
  ModalDivArrow,
  ModalTopText,
  ModalH1,
  ModalSpan,
  ModalBottom,
  ModalBottomLabels,
  ModalDots,
  Dot,
} from '../keyMetrics/styles';
import {
  layoutGraphic,
  schemaGraphicFatigue,
  schemaGraphicStrength,
  valuesKeyMetricsFatigue,
  valuesKeyMetricsStrength,
} from '../../../utils/constants/keyMetricsGraphic';
import {Teams} from '../../../utils/api';
import {deepGet} from '../../../utils/api/Utils';
import {ARMcontext} from '../../../utils/context/context';
import {getDateRange} from '../../../utils/helpers/getDateRange';
import {useLegendGraphic} from '../../../utils/hooks/useLengendGraphic';
import {capitalizeFirstLetters} from '../../../utils/hooks/text-formatter';
import TableKeyMetricsPlayer from '../../../components/Table/TableKeyMetricsPlayer';
import {default as LegendGraphic} from '../../../components/LegendGraphic/LegendGraphic';
import TableKeyMetricsFatiguePlayer from '../../../components/Table/TableKeyMetricsFatiguePlayer';
import {ArmRecovery, ArmFatigue, ArmStrength, ShoulderBalance, StrengthVelocityRatio} from '../../../utils/constants/fatigueZonesInfo';
import {TableHead, TableTopHeader, TableUnit, TableRow, TableSubHeader, TableColumn, TableBody} from '../../../components/Table/styles';
import {useLocation, useNavigate} from 'react-router-dom';

const FILTERS = [
  {title: 'All', id: 'all'},
  {title: 'Last 3 months', id: 'lastThreeMonths'},
  {title: 'Last month', id: 'lastMonth'},
  {title: 'Custom dates', id: 'customDates'},
];

export default () => {
  const location = useLocation();
  const path = location.pathname;
  let initialExam = {strength: true, fatigue: false};

  if (path.includes('fatigue')) {
    initialExam = {strength: false, fatigue: true};
  }
  const [keyScaleModal, setKeyScaleModal] = useState(false);
  const [radioExams, useRadioExams] = useState<any>(initialExam);
  const [recoveryOptions, useRecoveryOptions] = useState<Object>({});
  const fatigueZones = [ArmStrength, ShoulderBalance, StrengthVelocityRatio, ArmRecovery, ArmFatigue];
  const [keyMetrics, useKeyMetrics] = useState<Array<object | any>>([]);
  const [keyMetricsFatigue, setKeyMetricsFatigue] = useState<Array<object | any>>([]);
  const [playerWeight, setPlayerWeight] = useState<number>(150);
  const [keyMetricsGraphic, setKeyMetricsGraphic] = useState<Array<object | any>>([]);
  const {selectedPlayer} = useContext(ARMcontext);
  const [loadingStrengthTable, setLoadingStrengthTable] = useState(true);
  const [loadingFatigueTable, setLoadingFatigueTable] = useState(true);
  const [modalPage, setModalPage] = useState<number>(1);
  const [modalInfo, setModalInfo] = useState<any>(ArmStrength);
  const [filter, setFilter] = useState<Object>(FILTERS[0]);
  const [filterStartDate, setFilterStartDate] = useState(new Date());
  const [filterEndDate, setFilterEndDate] = useState(new Date());
  const [textRangeDate, setTextRangeDate] = useState<Array<string>>([]);
  const TEAMS = new Teams();
  const playerId =
    (selectedPlayer as { _id?: string; id?: string })?._id ??
    (selectedPlayer as { _id?: string; id?: string })?.id;

  useEffect(() => {
    if (radioExams.strength) setModalPage(1);
    else setModalPage(5);
  }, []);

  /** Context player is applied after mount when opening from dashboard activity (location.state). */
  useEffect(() => {
    if (!playerId) return;
    setLoadingStrengthTable(true);
    setLoadingFatigueTable(true);
    void fetchKeyMetrics(playerId);
  }, [playerId]);

  useEffect(() => {
    let loc = location.pathname;
    let word = 'keyMetrics';

    if (loc.substring(loc.length - word.length, loc.length) === word) {
      //history.replace('/players/keyMetrics/strength');
    }
  }, []);

  useEffect(() => {
    setModalInfo(fatigueZones[modalPage - 1]);
  }, [modalPage]);

  useEffect(() => {
    if (filter['id'] === 'customDates') {
      let data = [] as any;
      let path: Array<string> = [];

      if (radioExams.strength) {
        data = keyMetrics;
        path = ['armStrength', 'date'];
      } else {
        data = keyMetricsFatigue;
        path = ['date'];
      }

      let checked = getRecoveryChecked();
      let filteredData = getDateRange(data, path, filterStartDate, filterEndDate, 'YYYY/MM/DD');
      if (radioExams.strength) updateGraphic(filteredData, 'armStrengthLbs', checked);
      else updateGraphic(filteredData, 'strength', checked);
    }
  }, [filterStartDate, filterEndDate]);

  useEffect(() => {
    if (filter['id'] === 'all' && keyMetrics) {
      let data = [] as any;
      let path: Array<string> = [];

      if (radioExams.strength) {
        data = keyMetrics;
        path = ['armStrength', 'date'];
      } else {
        data = keyMetricsFatigue;
        path = ['date'];
      }
      const startDate = deepGet(data[data.length - 1], [...path]);
      const endDate = deepGet(data[0], [...path]);
      setFilterDates(startDate, endDate);
      let checked = getRecoveryChecked();
      let filteredData = getDateRange(data, path, startDate, endDate, 'YYYY/MM/DD');
      if (radioExams.strength) updateGraphic(filteredData, 'armStrengthLbs', checked);
      else updateGraphic(filteredData, 'strength', checked);
    }
  }, [keyMetrics, radioExams.strength]);

  async function fetchKeyMetrics(playerId): Promise<void> {
    let promises = [getKeyMetricsPlayer(playerId), getPostExamsFromPlayer(playerId)];
    await Promise.allSettled(promises);
  }

  async function getKeyMetricsPlayer(playerId): Promise<void> {
    const response = await TEAMS.GetKeyMetricsPlayer(playerId);
    if (response.status) {
      const playerWeightRaw = response.data.data.player?.weight_raw || 150;
      setPlayerWeight(playerWeightRaw);

      let dataResponse = response.data.data.strengthRecovery;
      useKeyMetrics(dataResponse);
      if (radioExams.strength) {
        updateGraphic(getLastThreeMonths(dataResponse, ['armStrength', 'date']), 'armStrengthLbs', playerWeightRaw);
      }
      setLoadingStrengthTable(false);
    }
  }

  async function getPostExamsFromPlayer(playerId): Promise<void> {
    let response = await TEAMS.GetPostExamsFromPlayer(playerId);
    if (response.status) {
      let dataResponse = response.data.data.entries;
      setKeyMetricsFatigue(dataResponse);
      if (radioExams.fatigue) {
        updateGraphic(getLastThreeMonths(dataResponse, ['date']), 'strength');
      }
      setLoadingFatigueTable(false);
    }
  }

  function updateGraphic(data: Array<Object>, graphic: string, checkedOrWeight?: string | number): void {
    let checked: string | undefined;
    let weight = playerWeight;

    if (typeof checkedOrWeight === 'string') {
      checked = checkedOrWeight;
    } else if (typeof checkedOrWeight === 'number') {
      weight = checkedOrWeight;
    }

    if (graphic === 'armStrengthLbs' || graphic === 'armStrength') {
      data.forEach(item => {
        item['strengthVelocityRatioVelocity'] = {velocity: item['strengthVelocityRatio']['velocity']};

        if (graphic === 'armStrengthLbs' && item['armStrength']) {
          const irRaw = item['armStrength']['internalRotation'] != null ? (item['armStrength']['internalRotation'] * weight) / 100 : null;
          const erRaw = item['armStrength']['externalRotation'] != null ? (item['armStrength']['externalRotation'] * weight) / 100 : null;

          item['armStrengthAbsolute'] = {
            date: item['armStrength']['date'],
            totalStrength: item['strengthVelocityRatio']?.totalStrength || null,
            internalRotation: irRaw,
            externalRotation: erRaw,
            scaption: item['armStrength']['scaption'] != null ? (item['armStrength']['scaption'] * weight) / 100 : null,
            grip: item['armStrength']['grip'] != null ? (item['armStrength']['grip'] * weight) / 100 : null,
          };
        }
      });
    }
    let dataKeyMetrics = useLegendGraphic(
      data,
      graphic === 'armStrengthLbs' || graphic === 'armStrength' ? ['armStrength', 'date'] : ['date'],
      graphic === 'armStrengthLbs' || graphic === 'armStrength' ? valuesKeyMetricsStrength : valuesKeyMetricsFatigue,
      graphic === 'armStrengthLbs' || graphic === 'armStrength' ? schemaGraphicStrength : schemaGraphicFatigue,
      checked,
    );
    setKeyMetricsGraphic(checked ? dataKeyMetrics[checked]['metrics'] : dataKeyMetrics[graphic]['metrics']);
    useRecoveryOptions(dataKeyMetrics);
    Plotly.newPlot(
      'keyMetricsGraphic',
      Object.values(checked ? dataKeyMetrics[checked]['metrics'] : dataKeyMetrics[graphic]['metrics']),
      {
        ...layoutGraphic,
        yaxis: {
          zerolinecolor: '#E6E7E9',
          title: checked ? dataKeyMetrics[checked].yAxisLabel : dataKeyMetrics[graphic].yAxisLabel,
        },
      },
      {displayModeBar: false},
    );
  }

  function handleRecovery(e: any) {
    const value = e.target.id;
    let newRecoveryObject = Object.assign({}, recoveryOptions);
    Object.keys(newRecoveryObject).forEach(key => {
      newRecoveryObject[key]['checked'] = false;
    });
    handleLegend(value);
    newRecoveryObject[value]['checked'] = true;
    useRecoveryOptions(newRecoveryObject);
  }

  function handleLegend(metric: string) {
    let selectedMetricGraphic = recoveryOptions[metric]['metrics'];
    let checkedLengeds: Array<Object> = [];
    Object.keys(selectedMetricGraphic).forEach(key => {
      if (selectedMetricGraphic[key].checked) checkedLengeds.push(selectedMetricGraphic[key]);
    });
    setKeyMetricsGraphic(selectedMetricGraphic);
    Plotly.newPlot(
      'keyMetricsGraphic',
      Object.values(checkedLengeds),
      {
        ...layoutGraphic,
        yaxis: {zerolinecolor: '#E6E7E9', title: recoveryOptions[metric].yAxisLabel},
      },
      {displayModeBar: false},
    );
  }

  function setFilterDates(startDate: string, endDate: string): void {
    setFilterStartDate(new Date(dayjs(startDate).format('YYYY/MM/DD')));
    setFilterEndDate(new Date(dayjs(endDate).format('YYYY/MM/DD')));
    setTextRangeDate([dayjs(startDate).format('MMM, DD YYYY'), dayjs(endDate).format('MMM, DD YYYY')]);
  }

  function getTextRange(data: Array<Object>, path: Array<string>, filterType?: string): void {
    let startDate: string = '',
      endDate: string = '';
    if (filterType === 'lastMonth') {
      let currentDay = dayjs().format('DD');
      let lastMonth = deepGet(data[data.length - 1], [...path]);
      startDate = `${dayjs(lastMonth).format('YYYY/MM')}/01`;
      endDate = `${dayjs(deepGet(data[0], [...path])).format('YYYY/MM')}/${currentDay}`;
    } else {
      startDate = deepGet(data[data.length - 1], [...path]);
      endDate = deepGet(data[0], [...path]);
    }
    setFilterDates(startDate, endDate);
  }

  function getRecoveryChecked(): string {
    let find = Object.keys(recoveryOptions).filter(key => recoveryOptions[key].checked);
    return find[0];
  }

  function getLastThreeMonths(data: any, path: Array<string>): Array<Object> {
    let currentDay = dayjs().format('DD');
    let currentDate = dayjs().format('YYYY/MM/DD');
    let thirdMonth = dayjs(currentDate).subtract(2, 'months');
    let dateThirdMonth = `${dayjs(thirdMonth).format('YYYY/MM')}/${currentDay}`;
    let filteredData = getDateRange(data, path, dateThirdMonth, currentDate, 'YYYY/MM/DD');
    setFilterDates(dateThirdMonth, currentDate);
    return filteredData;
  }

  function handleFilters(selected: Object): void {
    setFilter(selected);
    let data = [] as any;
    let path: Array<string> = [];
    let filteredData: Array<Object> = [];

    if (radioExams.strength) {
      data = keyMetrics;
      path = ['armStrength', 'date'];
    } else {
      data = keyMetricsFatigue;
      path = ['date'];
    }

    if (selected['id'] === 'customDates') return;
    if (selected['id'] === 'all') {
      filteredData = data;
      getTextRange(data, path);
    } else if (selected['id'] === 'lastThreeMonths') {
      filteredData = getLastThreeMonths(data, path);
    } else if (selected['id'] === 'lastMonth') {
      let lastMonth = dayjs().format('YYYY/MM');
      filteredData = data.filter((item: any) => dayjs(deepGet(item, [...path])).format('YYYY/MM') === lastMonth);
      getTextRange(filteredData, path, 'lastMonth');
    }

    let checked = getRecoveryChecked();
    if (radioExams.strength) updateGraphic(filteredData, 'armStrengthLbs', checked);
    else updateGraphic(filteredData, 'strength', checked);
  }

  function HandleRadioExams(e: any) {
    if (e.target.id === 'strength') {
      setModalPage(1);
      //history.replace('/players/keyMetrics/strength');
      updateGraphic(getLastThreeMonths(keyMetrics, ['armStrength', 'date']), 'armStrengthLbs');
      useRadioExams({strength: true, fatigue: false});
      setModalInfo(ArmRecovery);
    } else {
      setModalPage(5);
      //history.replace('/players/keyMetrics/fatigue');
      updateGraphic(getLastThreeMonths(keyMetricsFatigue, ['date']), 'strength');
      useRadioExams({strength: false, fatigue: true});
      setModalInfo(ArmFatigue);
    }
    setFilter(FILTERS[0]);
  }

  function manageModalPage(direction) {
    direction === 'up' ? setModalPage(modalPage + 1) : setModalPage(modalPage - 1);
  }

  function SetModalBottom(info) {
    let rows = Object.entries(info.info.zones);
    return (
      <ModalBottom>
        <ModalBottomLabels>
          {rows.map((row, rowIndex) => (
            <React.Fragment key={rowIndex}>
              <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
              {capitalizeFirstLetters(row[0], ' ')}
            </React.Fragment>
          ))}
        </ModalBottomLabels>
        <TableUnit color="black">
          <TableHead>
            <TableRow>
              <TableTopHeader hide={true}></TableTopHeader>
              <TableTopHeader colSpan={5} color="black">
                {String(info.info.title).toUpperCase()}
              </TableTopHeader>
            </TableRow>
            {info.info.categories && (
              <TableRow>
                <TableSubHeader hide={true} border={'none'}></TableSubHeader>
                {info.info.categories.map(category => (
                  <TableSubHeader key={category}>{category}</TableSubHeader>
                ))}
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} bgColor={row[0]}>
                <TableColumn width={'0px'}>
                  <Oval size={'8'} color={row[0]} margin={'0px 8px'} />
                </TableColumn>
                {Object.values(Object(row[1])).map((col, colIndex) => (
                  <TableColumn key={colIndex}>{String(col)}</TableColumn>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </TableUnit>
        {radioExams.strength && (
          <ModalDots>
            <Dot active={modalPage === 1} />
            <Dot active={modalPage === 2} />
            <Dot active={modalPage === 3} />
            <Dot active={modalPage === 4} />
          </ModalDots>
        )}
      </ModalBottom>
    );
  }

  return (
    <FluidContainer overflow={true}>
      <RadiosWrapper>
        <ExamRadios>
          <RadiosContainer onChange={HandleRadioExams} mBottom={'15px'}>
            <Radio
              theme="button"
              title="STRENGTH & RECOVERY"
              name="radioExams"
              id="strength"
              checked={radioExams.strength}
              dynamicActive={radioExams.strength}
              size={'16px'}
            />
            <Radio
              theme="button"
              title="FATIGUE"
              name="radioExams"
              id="fatigue"
              checked={radioExams.fatigue}
              dynamicActive={radioExams.fatigue}
              size={'16px'}
            />
          </RadiosContainer>
        </ExamRadios>
        <RadiosWrap>
          <FilterContainer>
            {radioExams.strength ? (
              <RadiosContainer onChange={handleRecovery} mBottom={'0px'}>
                {Object.keys(recoveryOptions).map(option => (
                  <Radio
                    theme="button"
                    name="radioRecovery"
                    id={recoveryOptions[option].id}
                    key={recoveryOptions[option].id}
                    title={recoveryOptions[option].title}
                    checked={recoveryOptions[option].checked}
                    dynamicActive={recoveryOptions[option].checked}
                    size={'16px'}
                  />
                ))}
              </RadiosContainer>
            ) : (
              <></>
            )}
            {((radioExams.strength && !loadingStrengthTable) || (radioExams.fatigue && !loadingFatigueTable)) && (
              <WrapperFilter>
                <ContainerDropdown>
                  <PowerDropdown
                    search={false}
                    dataArray={FILTERS}
                    onClick={handleFilters}
                    mPadding="4px 0 4px 10px;"
                    primaryTitle={filter['title']}
                  />
                </ContainerDropdown>
                {filter['id'] === 'customDates' ? (
                  <>
                    <MiddleText>FROM</MiddleText>
                    <InputDate
                      showRange={true}
                      closeIcon={false}
                      dropdownPicker={true}
                      date={filterStartDate}
                      endDate={filterEndDate}
                      setDate={setFilterStartDate}
                      setEndDate={setFilterEndDate}
                      minEndDate={filterStartDate}
                    />
                  </>
                ) : (
                  <>
                    <MiddleText>
                      FROM
                      <MiddleTextStrong> {textRangeDate[0]} </MiddleTextStrong>
                      TO <MiddleTextStrong>{textRangeDate[1]} </MiddleTextStrong>
                    </MiddleText>
                  </>
                )}
              </WrapperFilter>
            )}
          </FilterContainer>
          <RadiosContainer mBottom={'0px'}>
            <LegendGraphic
              recoveryOptions={recoveryOptions}
              keyMetricsGraphic={keyMetricsGraphic}
              setKeyMetricsGraphic={setKeyMetricsGraphic}
              handleLegend={(key: string) => handleLegend(key)}
            />
          </RadiosContainer>
        </RadiosWrap>
      </RadiosWrapper>
      {((radioExams.strength && loadingStrengthTable) || (radioExams.fatigue && loadingFatigueTable)) && (
        <div style={{width: '100%', display: 'block', alignItems: 'center'}}>
          <Loader height="90px" />
        </div>
      )}
      <KeyMetricsGraphic id="keyMetricsGraphic" />
      <RadiosWrapper>
        <ExamInfoContainer>
          {((radioExams.strength && !loadingStrengthTable) || (radioExams.fatigue && !loadingFatigueTable)) && (
            <ArmRecoveryContainer>
              <>
                <ArmRecoveryTop>
                  {radioExams.strength ? <TextContainer>KEY SCALE</TextContainer> : <TextContainer>ARM FATIGUE</TextContainer>}
                  {<ArmRecoveryInfoButton onClick={() => setKeyScaleModal(true)}>i</ArmRecoveryInfoButton>}
                </ArmRecoveryTop>
                <AlertWrapper>
                  <AlertContainer>
                    <Oval size={'8'} color={'watch'} />
                    <span> Watch</span>
                  </AlertContainer>
                  <AlertContainer>
                    <Oval size={'8'} color={'warning'} />
                    <span> Warning</span>
                  </AlertContainer>
                  <AlertContainer>
                    {!radioExams.fatigue && (
                      <>
                        <Oval size={'8'} color={'medical'} />
                        <span> Medical</span>
                      </>
                    )}
                  </AlertContainer>
                </AlertWrapper>
              </>
            </ArmRecoveryContainer>
          )}
        </ExamInfoContainer>
      </RadiosWrapper>
      <TableWrapper minHeight={'400px'}>
        {radioExams.strength && !loadingStrengthTable && <TableKeyMetricsPlayer dataTableContent={keyMetrics} player={selectedPlayer} />}
        {radioExams.fatigue && !loadingFatigueTable && <TableKeyMetricsFatiguePlayer dataTableContent={keyMetricsFatigue} />}
        {keyScaleModal && (
          <Modal active={setKeyScaleModal} maxWidth={'640px'} width={'80vw'} padding={'0'} margin={'40px auto'} minWidth={'480px'}>
            <ModalTop>
              {radioExams.strength ? (
                <>
                  <ModalDivArrow onClick={() => manageModalPage('down')}>{modalPage !== 1 && '<'}</ModalDivArrow>
                  {modalPage === 1 && (
                    <ModalTopText>
                      <ModalH1>ARM STRENGTH</ModalH1>
                      Arm Strength is represented by the relative strength, a metric that is expressed as muscular force divided by body
                      weight. Relative strength is important for health. As the body grows, throwing arm strength must also increase to
                      improve resistance to strains and sprains. Optimal relative strength for internal rotation and external rotation is
                      <ModalSpan>{' 20% '}</ModalSpan>
                      of body weight, while scaption (strength in arm elevation) and grip strength should be at least
                      <ModalSpan>{' 15% '}</ModalSpan>
                      body weight. If you are low in these values, the app will trigger exercise prescriptions to make improvements.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                    </ModalTopText>
                  )}
                  {modalPage === 2 && (
                    <ModalTopText>
                      <ModalH1>SHOULDER BALANCE</ModalH1>
                      Shoulder Balance, also known as the ER:IR Ratio, compares the strength balance of the backside (external rotators)
                      compared to the frontside (internal rotators) of your throwing arm. The optimal range for ER:IR Ratio is between
                      <ModalSpan>{' 0.85 - 1.05'}</ModalSpan>. If your ratio is below <ModalSpan>{' 0.85 '}</ModalSpan>your external
                      rotators are weak compared to your internal rotators. If your ratio is above <ModalSpan>{' 1.05'}</ModalSpan>, your
                      internal rotators are weak compared to your external rotators. The wider the strength gap between the shoulder ER
                      and IR, the higher the risk of injury.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                    </ModalTopText>
                  )}
                  {modalPage === 3 && (
                    <ModalTopText>
                      <ModalH1>STRENGTH VELOCITY RATIO</ModalH1>
                      Research shows that an increase of<ModalSpan>{' 1 mph '}</ModalSpan>of velocity can increase elbow torque by
                      <ModalSpan>{' 1 unit'}</ModalSpan>. This means that as velocity improves, stress to the elbow can also increase. To
                      protect the elbow from injury, we have build in a metric that evaluates total arm strength relative to maximum
                      velocity. Our optimal measure is <ModalSpan>{' 1.6'}</ModalSpan> for athletes 15 and over and{' '}
                      <ModalSpan>{' 1.3'}</ModalSpan> for athletes under 15 years. If you are below, our training programs will be focused
                      on raising total arm strength. If you are above and your velocity is low, you may be eligible for velocity
                      enhancement training
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                    </ModalTopText>
                  )}
                  {modalPage === 4 && (
                    <ModalTopText>
                      <ModalH1>ARM RECOVERY</ModalH1>A change in your weekly average Fresh exam indicates your throwing arm recovery.
                      Total arm strength decreases need to be less than 10 lbs and less than 5 lbs from average for each individual
                      muscle. If total strength decreases 10 lbs or more or 5 lbs or more for each muscle group, you are showing signs
                      that your recovery is less than optimal. Reducing pitch counts, pushing bullpens back and lower throwing intensity
                      can help improve recovery.
                      <br></br>
                      <br></br>
                      Recommendations:
                      <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                      Reduce throwing workloads while you increase strength and evaluate recovery habits.
                      <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                      Skip an outing, bullpen and high intensity weighted ball programming while training is intensified to increase
                      strength.
                      <ModalH1 marginBottom={'0px'}>MEDICAL</ModalH1>
                      Seek evaluation by a licensed medical professional.
                    </ModalTopText>
                  )}
                  <ModalDivArrow onClick={() => manageModalPage('up')}>{modalPage !== 4 && '>'}</ModalDivArrow>
                </>
              ) : (
                <>
                  <ModalTopText>
                    <ModalH1>ARM FATIGUE</ModalH1>
                    Arm Fatigue is determined by strength evaluations after high intensity throwing days to understand how fatigued your
                    throwing arm becomes after games, bullpens, and velocity training days. The goal is to retain more than 90% of your
                    strength from Fresh Exams (%Fresh). If you cannot retain 90% of your Fresh strength, you may need to lower your
                    workload and spend more time building strength and endurance.
                    <br></br>
                    <br></br>
                    Recommendations:
                    <ModalH1 marginBottom={'0px'}>WATCH</ModalH1>
                    Reduce throwing workloads for your next high intensity throwing day. For example if strength was not retained on the
                    game day, lower pitch counts on your next bullpen/game day/velo day, but maintain strength training.
                    <ModalH1 marginBottom={'0px'}>WARNING</ModalH1>
                    Reduce throwing workloads for your next high intensity throwing day. In addition to making adjustments to your next
                    high intensity throwing day, you need to focus on recovery habits and strength. It is a good idea after a Warning to
                    make the next day a low intensity throwing day or a complete day of rest.
                  </ModalTopText>
                </>
              )}
            </ModalTop>
            <SetModalBottom info={modalInfo} />
          </Modal>
        )}
      </TableWrapper>
    </FluidContainer>
  );
};
